import { render } from "./LogoutPage.vue?vue&type=template&id=a78dcf46&ts=true"
import script from "./LogoutPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoutPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/LogoutPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a78dcf46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a78dcf46', __exports__)) {
    api.reload('a78dcf46', __exports__)
  }
  
  module.hot.accept("./LogoutPage.vue?vue&type=template&id=a78dcf46&ts=true", () => {
    api.rerender('a78dcf46', render)
  })

}


export default __exports__